/* Simply Desserts theme behaviour. Vanilla JS. Observers first; the one scroll listener (range bar stuck state) is passive and frame-throttled. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* header height feeds the sticky offsets (jump links, gallery) */
  var header = $('.site-header');
  if (header && 'ResizeObserver' in window) {
    new ResizeObserver(function () {
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    }).observe(header);
  }

  /* mobile menu sheet */
  var sheet = $('[data-sheet]');
  var opener = $('[data-sheet-open]');
  function setSheet(open) {
    if (!sheet) return;
    sheet.classList.toggle('is-open', open);
    sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('sheet-open', open);
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var c = $('[data-sheet-close]', sheet); if (c) c.focus(); } else if (opener) { opener.focus(); }
  }
  if (opener) opener.addEventListener('click', function () { setSheet(true); });
  $$('[data-sheet-close]').forEach(function (b) { b.addEventListener('click', function () { setSheet(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && sheet.classList.contains('is-open')) setSheet(false); });

  /* add to cart without leaving the page */
  var toast = $('[data-toast]');
  var toastTimer;
  function showToast(text) {
    if (!toast) return;
    $('[data-toast-text]', toast).textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4500);
  }
  function refreshCount() {
    return fetch(window.sdRoutes.cart, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = e.submitter || $('[type="submit"]', form);
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; }
    fetch(window.sdRoutes.cartAdd, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add that to your cart.'); return d; }); })
      .then(function (item) {
        var qty = form.querySelector('input[name="quantity"]');
        var n = qty ? parseInt(qty.value, 10) || 1 : 1;
        showToast((n > 1 ? n + ' x ' : '') + (item.product_title || 'Item') + ' added to your cart');
        if (qty && form.classList.contains('card__quick')) qty.value = 1;
        return refreshCount();
      })
      .catch(function (err) { showToast(err.message); })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* product cards carry one real link (the name); the picture and the View Product / Build Your Box
     button hand their clicks to it, so screen readers and WAVE meet one link per product */
  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-card-go]');
    var link = go && go.closest('.card') && $('.card__title a', go.closest('.card'));
    if (!link) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey) window.open(link.href, '_blank', 'noopener');
    else window.location.href = link.href;
  });
  document.addEventListener('auxclick', function (e) {
    var go = e.button === 1 && e.target.closest('[data-card-go]');
    var link = go && go.closest('.card') && $('.card__title a', go.closest('.card'));
    if (link) window.open(link.href, '_blank', 'noopener');
  });

  /* quantity steppers */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = $('input', step.closest('.qty'));
    var next = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
    if (input.max) next = Math.min(parseInt(input.max, 10), next);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* product page tiles, phones: one image at a time with dots underneath that show and pick the image (Shaun 7 Oct) */
  $$('.pdp .tiles').forEach(function (row) {
    var tiles = $$(':scope > .tile', row);
    if (tiles.length < 2 || !('IntersectionObserver' in window)) return;
    var nav = document.createElement('div');
    nav.className = 'tiles__dots';
    nav.setAttribute('role', 'group');
    nav.setAttribute('aria-label', 'Product images');
    var dots = tiles.map(function (t, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Show ' + (t.classList.contains('tile--video') ? 'video' : 'picture') + ' ' + (i + 1) + ' of ' + tiles.length);
      b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function () { row.scrollTo({ left: row.scrollLeft + t.getBoundingClientRect().left - row.getBoundingClientRect().left, behavior: 'smooth' }); });
      nav.appendChild(b);
      return b;
    });
    row.after(nav);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var n = tiles.indexOf(e.target);
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === n ? 'true' : 'false'); });
      });
    }, { root: row, threshold: 0.6 });
    tiles.forEach(function (t) { io.observe(t); });
  });

  /* product media viewer (Shaun 7 Oct), modelled on the old site's Amazon-style gallery modal: a big viewer, Images /
     Videos tabs with counts, a thumbnail strip, arrows and the left / right keys. A native dialog: Escape closes it,
     the page behind is inert, Tab stays inside and focus goes back to whatever opened it. Videos are YouTube
     (no-cookie), loaded only when shown and emptied when you move on or close. */
  $$('[data-mgal]').forEach(function (dlg) {
    var data;
    try { data = JSON.parse($('[data-mgal-data]', dlg).textContent); } catch (err) { return; }
    var sets = { i: data.images || [], v: data.videos || [], r: data.recipes || [] };
    var view = $('[data-mgal-view]', dlg), strip = $('[data-mgal-thumbs]', dlg), body = $('.mgal__body', dlg);
    var recipes = $('[data-mgal-recipes]', dlg);
    var count = $('[data-mgal-count]', dlg), caption = $('[data-mgal-alt]', dlg);
    var panel = $('#mgal-panel', dlg), tabs = $$('[data-mgal-tab]', dlg), steps = $$('[data-mgal-step]', dlg);
    var kind = 'i', index = 0, opener = null;
    function sized(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function label(k, n) { return (k === 'v' ? 'Video ' : 'Photo ') + (n + 1) + ' of ' + sets[k].length; }
    function setTab(k) {
      kind = k;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-mgal-tab') === k;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on) panel.setAttribute('aria-labelledby', t.id);
      });
      /* Recipes tab: the viewer gives way to a grid of recipe cards, built the first time the tab opens */
      body.classList.toggle('mgal__body--recipes', k === 'r');
      if (recipes) recipes.hidden = k !== 'r';
      if (k === 'r') {
        view.innerHTML = '';
        var grid = $('.mgal__rgrid', recipes);
        /* the recipes live in the recipes hub: its publish puts the list in a theme asset (rows of
           [address, title, photo, widths, products]); this product's rows are picked out the first time the tab opens */
        if (!grid.children.length && !recipes.getAttribute('data-loading')) {
          recipes.setAttribute('data-loading', '1');
          var base = recipes.getAttribute('data-base') || '';
          fetch(recipes.getAttribute('data-src')).then(function (res) { return res.json(); }).then(function (feed) {
            var at = feed.products.indexOf(recipes.getAttribute('data-product'));
            feed.items.forEach(function (r) {
              if (at < 0 || r[4].indexOf(at) < 0) return;
              var li = document.createElement('li');
              var a = document.createElement('a');
              a.href = base + r[0];
              a.className = 'mgal__recipe';
              a.target = '_blank';                  /* Shaun 7 Oct: the recipe opens beside the product */
              a.rel = 'noopener';
              if (r[2]) {
                var img = document.createElement('img');
                var ws = r[3] || [];
                if (ws.length) {
                  img.srcset = ws.map(function (w) { return base + r[2] + '-' + w + '.webp ' + w + 'w'; }).join(', ');
                  img.sizes = '(min-width: 1024px) 240px, (min-width: 768px) 30vw, 46vw';
                  img.src = base + r[2] + '-' + ws[Math.min(1, ws.length - 1)] + '.webp';
                } else { img.src = base + r[2]; }
                img.alt = '';
                img.width = 400; img.height = 400;
                img.loading = 'lazy';
                img.decoding = 'async';
                a.appendChild(img);
              }
              var span = document.createElement('span');
              span.textContent = r[1];
              a.appendChild(span);
              var note = document.createElement('span');
              note.className = 'visually-hidden';
              note.textContent = ' (opens in a new tab)';
              a.appendChild(note);
              li.appendChild(a);
              grid.appendChild(li);
            });
          }).catch(function () {
            recipes.removeAttribute('data-loading');
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = base + '/recipes/'; a.className = 'mgal__recipe'; a.textContent = 'See all recipes';
            li.appendChild(a); grid.appendChild(li);
          });
        }
        recipes.scrollTop = 0;
        return;
      }
      strip.setAttribute('aria-label', k === 'v' ? 'Videos' : 'Photos');
      strip.innerHTML = '';
      sets[k].forEach(function (m, n) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mgal__thumb' + (k === 'v' ? ' mgal__thumb--video' : '');
        b.setAttribute('data-mgal-go', n);
        b.setAttribute('aria-label', label(k, n) + (m.alt ? ': ' + m.alt : ''));
        var img = document.createElement('img');
        img.src = k === 'v' ? m.poster : sized(m.src, 200);
        img.alt = '';
        img.width = 96; img.height = 96;
        img.loading = 'lazy';
        b.appendChild(img);
        li.appendChild(b);
        strip.appendChild(li);
      });
      steps.forEach(function (b) { b.hidden = sets[k].length < 2; });
    }
    function show(n) {
      var list = sets[kind];
      if (kind === 'r' || !list.length) return;
      index = (n + list.length) % list.length;
      var m = list[index];
      view.innerHTML = '';
      if (kind === 'v') {
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(m.id) + '?autoplay=1&rel=0&playsinline=1';
        f.title = m.alt || 'Product video';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        view.appendChild(f);
      } else {
        var img = document.createElement('img');
        img.src = sized(m.src, 1200);
        img.srcset = sized(m.src, 800) + ' 800w, ' + sized(m.src, 1200) + ' 1200w, ' + sized(m.src, 2000) + ' 2000w';
        img.sizes = '(min-width: 1024px) 60vw, 92vw';
        img.alt = m.alt || '';
        img.decoding = 'async';
        view.appendChild(img);
      }
      view.classList.toggle('mgal__view--video', kind === 'v');
      count.textContent = label(kind, index);
      caption.textContent = m.alt || '';
      $$('[data-mgal-go]', strip).forEach(function (b, i) {
        b.setAttribute('aria-current', i === index ? 'true' : 'false');
        if (i === index && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }
    function open(slot, from) {
      var parts = (slot || 'i:0').split(':');
      var k = sets[parts[0]] && sets[parts[0]].length ? parts[0] : 'i';
      opener = from || document.activeElement;
      setTab(k);
      if (!dlg.open) dlg.showModal();
      show(parseInt(parts[1], 10) || 0);
      $('[data-mgal-close]', dlg).focus();
    }
    var page = dlg.closest('.pdp__media') || document;
    $$('[data-mgal-open]', page).forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (!dlg.showModal) return;              /* no dialog support: the tile's own link still works */
        e.preventDefault();
        open(el.getAttribute('data-mgal-open'), el);
      });
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-mgal-close]')) { dlg.close(); return; }
      var step = e.target.closest('[data-mgal-step]');
      if (step) { show(index + parseInt(step.getAttribute('data-mgal-step'), 10)); return; }
      var go = e.target.closest('[data-mgal-go]');
      if (go) { show(parseInt(go.getAttribute('data-mgal-go'), 10)); return; }
      var tab = e.target.closest('[data-mgal-tab]');
      if (tab) { setTab(tab.getAttribute('data-mgal-tab')); show(0); }
    });
    dlg.addEventListener('keydown', function (e) {
      var tab = e.target.closest('[data-mgal-tab]');
      if (tab && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        var t = tabs[(tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        setTab(t.getAttribute('data-mgal-tab')); show(0); t.focus();
        e.preventDefault();
        return;
      }
      if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && kind !== 'r') {
        show(index + (e.key === 'ArrowRight' ? 1 : -1));
        e.preventDefault();
      } else if (e.key === 'Tab') {
        /* keep Tab inside the viewer rather than letting it reach the browser's own controls */
        var f = $$('button:not([hidden]), iframe, a[href], [tabindex="0"]', dlg).filter(function (el) { return el.offsetParent !== null && el.tabIndex >= 0; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
    });
    dlg.addEventListener('close', function () {
      view.innerHTML = '';
      if (opener && opener.focus) opener.focus();
    });
  });

  /* product gallery */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main]', g);
    $$('[data-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.src; main.srcset = t.dataset.srcset || ''; main.alt = t.dataset.alt || '';
        $$('[data-thumb]', g).forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
      });
    });
  });

  /* quote slider and any [data-slider] with prev/next buttons */
  $$('[data-slider]').forEach(function (s) {
    var track = $('[data-track]', s);
    $$('[data-dir]', s).forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = parseInt(b.dataset.dir, 10);
        var max = track.scrollWidth - track.clientWidth;
        var to = track.scrollLeft + dir * track.clientWidth;
        if (s.classList.contains('rail-wrap')) to = Math.max(0, Math.min(max, to));
        else if (to > max + 4) to = 0; else if (to < -4) to = max;
        track.scrollTo({ left: to, behavior: 'smooth' });
      });
    });
  });

  /* rails: fade out the arrow that has nowhere left to go */
  if ('IntersectionObserver' in window) {
    $$('.rail-wrap').forEach(function (wrap) {
      var track = $('[data-track]', wrap), prev = $('[data-dir="-1"]', wrap), next = $('[data-dir="1"]', wrap);
      var cards = track ? track.children : [];
      if (!cards.length || !prev || !next) return;
      var edge = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === cards[0]) prev.disabled = en.isIntersecting;
          if (en.target === cards[cards.length - 1]) next.disabled = en.isIntersecting;
        });
      }, { root: track, threshold: 0.9 });
      edge.observe(cards[0]); edge.observe(cards[cards.length - 1]);
    });
  }

  /* header dropdown (Shop): mouse hover opens after a short pause and closes after a longer one (no flicker); the
     chevron button toggles it for touch and keyboard; arrows move through the links, Esc closes and returns focus */
  $$('[data-navdrop]').forEach(function (navDrop) {
    var navBtn = $('.nav__toggle', navDrop), navMenu = $('.nav__menu', navDrop);
    if (!navBtn || !navMenu) return;
    var navLinks = $$('a', navMenu), navTimer = 0;
    var navSet = function (open, focusFirst) {
      clearTimeout(navTimer);
      navBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      navMenu.hidden = !open;
      if (open && focusFirst && navLinks[0]) navLinks[0].focus();
    };
    var navLater = function (open, ms) { clearTimeout(navTimer); navTimer = setTimeout(function () { navSet(open); }, ms); };
    navDrop.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') navLater(true, 120); });
    navDrop.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') navLater(false, 280); });
    navBtn.addEventListener('click', function () { navSet(navBtn.getAttribute('aria-expanded') !== 'true'); });
    navDrop.addEventListener('keydown', function (e) {
      var i = navLinks.indexOf(document.activeElement);
      if (e.key === 'Escape' && !navMenu.hidden) { navSet(false); navBtn.focus(); e.preventDefault(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); if (navMenu.hidden) navSet(true, true); else navLinks[Math.min(i + 1, navLinks.length - 1)].focus(); }
      else if (e.key === 'ArrowUp' && i >= 0) { e.preventDefault(); if (i === 0) navBtn.focus(); else navLinks[i - 1].focus(); }
      else if (e.key === 'Home' && i >= 0) { e.preventDefault(); navLinks[0].focus(); }
      else if (e.key === 'End' && i >= 0) { e.preventDefault(); navLinks[navLinks.length - 1].focus(); }
    });
    navDrop.addEventListener('focusout', function (e) { if (!navDrop.contains(e.relatedTarget)) navSet(false); });
    document.addEventListener('pointerdown', function (e) { if (!navDrop.contains(e.target)) navSet(false); });
  });

  /* shop and range pages: the range bar is see-through while it rests in the hero band (the hero colour runs on
     behind it, sized by --jump-h) and only takes a solid background once it sticks under the header */
  var jumpBar = document.querySelector('.jump--tint');
  if (jumpBar) {
    var jumpSize = function () { document.documentElement.style.setProperty('--jump-h', jumpBar.offsetHeight + 'px'); };
    jumpSize();
    window.addEventListener('resize', jumpSize);
    /* stuck = resting at its sticky top after a scroll; read live each frame, so a resize or a header that
       changes height never leaves it wrong (Shaun 7 Oct: the phone bar stayed see-through) */
    var jumpTick = false;
    var jumpCheck = function () {
      jumpTick = false;
      var top = parseFloat(getComputedStyle(jumpBar).top) || 0;
      jumpBar.classList.toggle('is-stuck', window.scrollY > 0 && jumpBar.getBoundingClientRect().top <= top + 1);
    };
    var jumpQueue = function () { if (!jumpTick) { jumpTick = true; requestAnimationFrame(jumpCheck); } };
    window.addEventListener('scroll', jumpQueue, { passive: true });
    window.addEventListener('resize', jumpQueue);
    jumpCheck();
  }

  /* shop page: highlight the group in view */
  var chips = $$('[data-jump]');
  var pick = $('[data-jump-pick]');
  var jumping = false;
  /* phone range picker: a button opening a themed listbox (button + listbox, aria-activedescendant) */
  var pickBtn = pick && $('button', pick);
  var pickList = pick && $('[role="listbox"]', pick);
  var pickOpts = pick ? $$('[role="option"]', pick) : [];
  var pickLabel = pick && $('[data-jump-label]', pick);
  var pickAt = 0;
  function setCurrent(href) {
    pickOpts.forEach(function (o) {
      var on = o.getAttribute('data-value') === href;
      o.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) pickLabel.textContent = o.textContent;
    });
  }
  /* one place marks the current range: the pill on desktop, the dropdown's label on phone.
     While a picked jump scrolls past other ranges the label holds still. */
  function markRange(href) {
    if (jumping) return;
    chips.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('href') === href); });
    if (pick) setCurrent(href);
  }
  function activate(i) {
    pickAt = Math.max(0, Math.min(pickOpts.length - 1, i));
    pickOpts.forEach(function (o, j) { o.classList.toggle('is-focus', j === pickAt); });
    pickList.setAttribute('aria-activedescendant', pickOpts[pickAt].id);
    pickOpts[pickAt].scrollIntoView({ block: 'nearest' });
  }
  function setPick(open, refocus) {
    if (!pick || open === !pickList.hidden) return;
    pickList.hidden = !open;
    pickBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var cur = pickOpts.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; });
      activate(cur < 0 ? 0 : cur);
      pickList.focus({ preventScroll: true });
    } else if (refocus) pickBtn.focus({ preventScroll: true });
  }
  function choose(i) {
    var href = pickOpts[i].getAttribute('data-value');
    setPick(false, true);
    setCurrent(href);
    var target = href === '#shop-all' ? null : document.getElementById(href.slice(1));
    chips.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('href') === href); });
    jumping = true;
    var done = function () { jumping = false; window.removeEventListener('scrollend', done); };
    window.addEventListener('scrollend', done);
    setTimeout(done, 1200);
    if (!target) { window.scrollTo(0, 0); return; }
    /* land with the range heading just under the stuck bar, so nothing of the section above peeks out */
    var bar = document.querySelector('.jump');
    var stuck = bar ? (parseFloat(getComputedStyle(bar).top) || 0) + bar.offsetHeight : 0;
    var pad = parseFloat(getComputedStyle(target).paddingTop) || 0;
    window.scrollTo(0, target.getBoundingClientRect().top + window.scrollY + pad - stuck - 20);
  }
  if (pick) {
    pickBtn.addEventListener('click', function () { setPick(pickList.hidden); });
    pickBtn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); setPick(true); }
    });
    pickOpts.forEach(function (o, i) { o.addEventListener('click', function () { choose(i); }); });
    pickList.addEventListener('mousedown', function (e) { e.preventDefault(); });
    pickList.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown') activate(pickAt + 1);
      else if (k === 'ArrowUp') activate(pickAt - 1);
      else if (k === 'Home') activate(0);
      else if (k === 'End') activate(pickOpts.length - 1);
      else if (k === 'Enter' || k === ' ') choose(pickAt);
      else if (k === 'Escape') setPick(false, true);
      else if (k === 'Tab') { setPick(false); return; }
      else return;
      e.preventDefault();
    });
    document.addEventListener('pointerdown', function (e) { if (!pick.contains(e.target)) setPick(false); });
    pickList.addEventListener('focusout', function (e) { if (!pick.contains(e.relatedTarget)) setPick(false); });
  }
  if (chips.length && 'IntersectionObserver' in window) {
    var atHero = false;
    var targets = chips.map(function (c) { return document.getElementById(c.getAttribute('href').slice(1)); }).filter(Boolean);
    var io = new IntersectionObserver(function (entries) {
      if (atHero) return;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        markRange('#' + en.target.id);
      });
    }, { rootMargin: '-35% 0px -55% 0px' });
    targets.forEach(function (t) { io.observe(t); });
    /* while the hero is in view the current range is All (on a phone the first range already reaches the spy band);
       leaving it, the range sitting in the band takes over */
    var shopHero = $('.shop-hero');
    if (shopHero) {
      new IntersectionObserver(function (en) {
        atHero = en[0].isIntersecting;
        if (atHero) { markRange(chips[0].getAttribute('href')); return; }
        var band = window.innerHeight * 0.45;
        var hit = targets.filter(function (t) { var r = t.getBoundingClientRect(); return r.top <= band && r.bottom > band; })[0];
        if (hit) markRange('#' + hit.id);
      }, { threshold: 0.5 }).observe(shopHero);
    }
  }

  /* product page flavor picker: button + floating listbox (aria-activedescendant); picking a flavor opens its page */
  $$('[data-flavor]').forEach(function (fl) {
    var btn = $('button', fl), list = $('[role="listbox"]', fl), opts = $$('[role="option"]', fl), at = 0;
    function activate(i) {
      at = Math.max(0, Math.min(opts.length - 1, i));
      opts.forEach(function (o, j) { o.classList.toggle('is-focus', j === at); });
      list.setAttribute('aria-activedescendant', opts[at].id);
      /* keep the row in view inside the list only; scrollIntoView would also move the page */
      var o = opts[at];
      if (o.offsetTop < list.scrollTop) list.scrollTop = o.offsetTop - 8;
      else if (o.offsetTop + o.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = o.offsetTop + o.offsetHeight - list.clientHeight + 8;
    }
    function setOpen(open, refocus) {
      if (open === !list.hidden) return;
      list.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var cur = opts.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; });
        activate(cur < 0 ? 0 : cur);
        list.focus({ preventScroll: true });
      } else if (refocus) btn.focus({ preventScroll: true });
    }
    function choose(i) {
      var o = opts[i];
      if (o.getAttribute('aria-selected') === 'true') { setOpen(false, true); return; }
      opts.forEach(function (x) { x.setAttribute('aria-selected', x === o ? 'true' : 'false'); });
      setOpen(false, true);
      window.location.href = o.getAttribute('data-href');
    }
    btn.addEventListener('click', function () { setOpen(list.hidden); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); setOpen(true); }
    });
    opts.forEach(function (o, i) {
      o.addEventListener('click', function () { choose(i); });
      o.addEventListener('pointermove', function () { if (at !== i) activate(i); });
    });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown') activate(at + 1);
      else if (k === 'ArrowUp') activate(at - 1);
      else if (k === 'Home') activate(0);
      else if (k === 'End') activate(opts.length - 1);
      else if (k === 'Enter' || k === ' ') choose(at);
      else if (k === 'Escape') setOpen(false, true);
      else if (k === 'Tab') { setOpen(false); return; }
      else return;
      e.preventDefault();
    });
    document.addEventListener('pointerdown', function (e) { if (!fl.contains(e.target)) setOpen(false); });
    list.addEventListener('focusout', function (e) { if (!fl.contains(e.relatedTarget)) setOpen(false); });
  });

  /* back to top appears after one screen */
  var top = $('[data-to-top]');
  if (top && 'IntersectionObserver' in window) {
    var mark = document.createElement('div');
    mark.style.cssText = 'position:absolute;top:100vh;height:1px;width:1px;pointer-events:none';
    document.body.appendChild(mark);
    new IntersectionObserver(function (en) { top.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0; }).observe(mark);
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* product page, phones and tablets: the sticky Add to Cart bar shows once the main button has scrolled
     up out of view, and hides while the main button or the footer is on screen */
  var sbar = $('[data-sbar]');
  var sbarForm = sbar && document.getElementById($('[form]', sbar).getAttribute('form'));
  var sbarMain = sbarForm && $('.buy__row', sbarForm);
  if (sbarMain && 'IntersectionObserver' in window) {
    var sbarBtn = $('[form]', sbar), sbarSmall = window.matchMedia('(max-width: 1023px)');
    var sbarPast = false, sbarAtFoot = false;
    var setBar = function () {
      var on = sbarSmall.matches && sbarPast && !sbarAtFoot;
      if (!on && sbar.contains(document.activeElement)) $('[type="submit"]', sbarForm).focus({ preventScroll: true });
      sbar.classList.toggle('is-on', on);
      document.body.classList.toggle('sbar-on', on);
    };
    /* the root reaches far below the screen, so the main button counts as past only once it has gone off the
       top (a jump from below the screen to above it still fires) */
    new IntersectionObserver(function (en) { sbarPast = !en[0].isIntersecting; setBar(); },
      { rootMargin: '0px 0px 100000px 0px' }).observe(sbarMain);
    var sbarFoot = $('.site-footer');
    if (sbarFoot) new IntersectionObserver(function (en) { sbarAtFoot = en[0].isIntersecting; setBar(); }).observe(sbarFoot);
    if (sbarSmall.addEventListener) sbarSmall.addEventListener('change', setBar);
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { document.documentElement.style.setProperty('--sbar-h', sbar.offsetHeight + 'px'); }).observe(sbar);
    }
    /* products with variants: the bar's price and button follow the variant picked in the main form */
    var vData = $('[data-sbar-variants]', sbar), vPick = $('select[name="id"]', sbarForm);
    if (vData && vPick) {
      var sbarVariants = JSON.parse(vData.textContent);
      vPick.addEventListener('change', function () {
        var v = sbarVariants[vPick.value];
        if (!v) return;
        $('[data-sbar-price]', sbar).textContent = v.price;
        sbarBtn.disabled = !v.available;
        sbarBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      });
    }
  }

  /* tabs: click or arrow keys switch the visible range */
  $$('[data-tabs]').forEach(function (box) {
    var tabs = $$('[role="tab"]', box);
    function pick(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t, false); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        pick(tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length], true);
      });
    });
  });

  /* scroll reveal: each element fades up once, siblings stagger slightly */
  var revealEls = $$('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var ro = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.style.setProperty('--d', (n++ * 0.07) + 's');
        en.target.classList.add('is-in');
        ro.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { ro.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* hero video: respects reduced motion, rests when off screen, and can always be paused */
  $$('[data-hero-video]').forEach(function (box) {
    /* phones: the sticker (laid out at 96px) is scaled to exactly the headline's height beside it */
    var sticker = $('.sticker--hero', box), hero = box.closest('.hero'), h1 = hero && $('h1', hero);
    if (sticker && h1 && 'ResizeObserver' in window) {
      var phone = window.matchMedia('(max-width: 599px)');
      var fit = function () {
        if (phone.matches) sticker.style.setProperty('--sticker-scale', (h1.getBoundingClientRect().height / 96).toFixed(4));
        else sticker.style.removeProperty('--sticker-scale');
      };
      new ResizeObserver(fit).observe(h1);
    }
    var clip = $('.hero__clip', box), btn = $('[data-video-toggle]', box);
    var video = clip && clip.shadowRoot ? $('video', clip.shadowRoot) : $('video', box);
    if (!video || !btn) return;
    var userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show() {
      var paused = video.paused;
      $('[data-when="playing"]', btn).hidden = paused;
      $('[data-when="paused"]', btn).hidden = !paused;
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }
    if (userPaused) { video.removeAttribute('autoplay'); video.pause(); }
    video.addEventListener('play', show); video.addEventListener('pause', show); show();
    btn.addEventListener('click', function () {
      if (video.paused) { userPaused = false; video.play(); } else { userPaused = true; video.pause(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { if (!userPaused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); } }
        else video.pause();
      }, { threshold: 0.25 }).observe(box);
    }
  });

  /* announcement bar: rotates its messages; pauses on hover, on focus, when the arrows are used
     and for anyone who prefers reduced motion */
  $$('[data-announce]').forEach(function (bar) {
    var items = $$('[data-announce-item]', bar);
    if (items.length < 2) return;
    var at = 0, timer = null, stopped = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      at = (n + items.length) % items.length;
      items.forEach(function (it, i) {
        var on = i === at;
        it.classList.toggle('is-on', on);
        if (on) it.removeAttribute('aria-hidden'); else it.setAttribute('aria-hidden', 'true');
        var link = $('a', it); if (link) link.tabIndex = on ? 0 : -1;
      });
    }
    function start() { if (stopped || timer) return; timer = setInterval(function () { show(at + 1); }, parseInt(bar.dataset.interval, 10) || 6000); }
    function stop() { clearInterval(timer); timer = null; }
    $$('[data-announce-dir]', bar).forEach(function (b) {
      b.addEventListener('click', function () { stopped = true; stop(); show(at + parseInt(b.dataset.announceDir, 10)); });
    });
    bar.addEventListener('mouseenter', stop); bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop); bar.addEventListener('focusout', start);
    start();
  });

  /* cart page: update a line when its quantity changes */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (input) input.form.submit();
  });

  /* video window: a play button fills the section's dialog with its video, recipe name and link;
     the arrows (and the left / right keys) step through the section's other recipe videos */
  var vList = [], vIndex = 0, vModal = null;
  function showVideo(i) {
    if (!vModal || !vList.length) return;
    vIndex = (i + vList.length) % vList.length;
    var play = vList[vIndex];
    var src = play.getAttribute('data-video');
    var frame = document.createElement('iframe');
    frame.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1&playsinline=1';
    frame.title = play.getAttribute('data-video-title') || 'Recipe video';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    var holder = $('[data-vmodal-frame]', vModal);
    holder.innerHTML = '';
    holder.appendChild(frame);
    $('[data-vmodal-title]', vModal).textContent = play.getAttribute('data-video-title') || 'Recipe video';
    $('[data-vmodal-link]', vModal).setAttribute('href', play.getAttribute('data-video-link') || '#');
  }
  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-video]');
    if (play) {
      var scope = play.closest('section') || document;
      var modal = $('[data-vmodal]', scope) || $('[data-vmodal]');
      if (!modal || !modal.showModal) { window.location.href = play.getAttribute('data-video-link'); return; }
      vModal = modal;
      vList = $$('[data-video]', scope);
      $$('[data-vmodal-step]', modal).forEach(function (b) { b.hidden = vList.length < 2; });
      showVideo(vList.indexOf(play));
      modal.showModal();
      return;
    }
    var step = e.target.closest('[data-vmodal-step]');
    if (step) { showVideo(vIndex + parseInt(step.getAttribute('data-vmodal-step'), 10)); return; }
    var open = e.target.closest('[data-vmodal]');
    if (open && (e.target === open || e.target.closest('[data-vmodal-close]'))) open.close();
  });
  document.addEventListener('keydown', function (e) {
    if (!vModal || !vModal.open || vList.length < 2) return;
    if (e.key === 'ArrowRight') showVideo(vIndex + 1);
    if (e.key === 'ArrowLeft') showVideo(vIndex - 1);
  });
  /* closing by any route (button, backdrop, Escape) stops the video */
  $$('[data-vmodal]').forEach(function (modal) {
    modal.addEventListener('close', function () { $('[data-vmodal-frame]', modal).innerHTML = ''; });
  });

  /* questions and answers: one button opens every answer, then closes them again */
  $$('[data-faq]').forEach(function (faq) {
    var btn = $('[data-faq-toggle]', faq);
    var items = $$('details', faq);
    if (!btn || !items.length) return;
    function sync() {
      var allOpen = items.every(function (d) { return d.open; });
      btn.textContent = allOpen ? btn.getAttribute('data-close-label') : btn.getAttribute('data-open-label');
      btn.setAttribute('aria-expanded', allOpen ? 'true' : 'false');
    }
    btn.addEventListener('click', function () {
      var open = !items.every(function (d) { return d.open; });
      items.forEach(function (d) { d.open = open; });
      sync();
    });
    items.forEach(function (d) { d.addEventListener('toggle', sync); });
    sync();
  });

  /* product reviews: Write a Review opens the form, it posts to the MRP (pending until approved), Show More reveals the rest */
  $$('[data-reviews]').forEach(function (box) {
    var open = $('[data-review-open]', box);
    var form = $('[data-review-form]', box);
    var more = $('[data-review-show-more]', box);
    if (more) more.addEventListener('click', function () {
      var hidden = $$('[data-review-more][hidden]', box);
      hidden.forEach(function (li) { li.hidden = false; });
      more.parentNode.remove();
      var first = hidden[0] && $('h3', hidden[0]);
      if (first) { first.tabIndex = -1; first.focus(); }
    });
    if (!open || !form) return;
    var status = $('[data-review-status]', form);
    var submit = $('button[type="submit"]', form);
    function setOpen(on) {
      form.hidden = !on;
      open.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { var first = $('input[name="rating"]', form); if (first) first.focus(); } else open.focus();
    }
    open.addEventListener('click', function () { setOpen(form.hidden); });
    $('[data-review-cancel]', form).addEventListener('click', function () { setOpen(false); });
    function say(msg, bad) { status.textContent = msg; status.classList.toggle('is-error', !!bad); }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fields = $$('input[required], textarea[required]', form).filter(function (f) { return f.type !== 'radio'; });
      var bad = null;
      fields.forEach(function (f) { var ok = f.checkValidity(); f.setAttribute('aria-invalid', ok ? 'false' : 'true'); if (!ok && !bad) bad = f; });
      var rated = $('input[name="rating"]:checked', form);
      if (!rated) { say('Pick a star rating.', true); $('input[name="rating"]', form).focus(); return; }
      if (bad) { say('Please fill in ' + ($('label[for="' + bad.id + '"]', form) || {}).textContent.replace('*', '').trim().toLowerCase() + '.', true); bad.focus(); return; }
      var data = {};
      new FormData(form).forEach(function (v, k) { data[k] = v; });
      submit.disabled = true;
      say('Sending your review…');
      fetch(form.getAttribute('data-endpoint'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && res.body.error || 'Something went wrong. Please try again.');
          form.reset();
          $$('[aria-invalid]', form).forEach(function (f) { f.removeAttribute('aria-invalid'); });
          say(res.body && res.body.published
            ? 'Thank you! Your review is live with a Verified Buyer badge. Refresh the page to see it.'
            : 'Thank you! Your review is in. It will show here once we have checked it.');
        })
        .catch(function (err) { say(err.message && err.message !== 'Failed to fetch' ? err.message : 'We could not send your review. Please try again.', true); })
        .then(function () { submit.disabled = false; });
    });
  });
  /* ---------- search (Shaun 13 Oct; answers first 14 Oct): one index, assets/sd-search.json (search_index.py), searched
     here in the browser. It covers the store and the static hubs: FAQ answers, products, recipes, hub guides, blog, press
     and the store's pages. The header panel and the search page both run sRank() below, so they show the same answer
     card, the same groups in the same order and the same counts: FAQ first, Pages last, the rest ranked by how well
     their best results match (stable tie-break Products > Recipes > Guides > Blog > Press). ---------- */
  /* sd-search-core: no DOM in here, so search_test.js can run it in Node against the index */
  var sGroups = [['h', 'FAQ', 'answers'], ['p', 'Products', 'products'], ['r', 'Recipes', 'recipes'], ['g', 'Guides', 'guides'], ['b', 'Blog', 'blog posts'], ['n', 'Press', 'press stories'], ['x', 'Pages', 'pages']];
  var sOrder = { h: 0, p: 1, r: 2, g: 3, b: 4, n: 5, x: 6 };
  /* words that carry no subject. Question words still mark a query as a question (sAsk) before they are dropped. */
  var sStop = {};
  ('a an and the is of for to in on with how what whats can does doesnt do did dont my i it its im are am be was were your you ' +
   'me us we our this that these those there their at by or from as so if any much many some should would could will just ' +
   'get got about why where when which who need').split(' ').forEach(function (w) { sStop[w] = 1; });
  /* words in an FAQ question that say nothing about what it answers (for "does this FAQ fit the query") */
  var sFill = { simply: 1, dessert: 1, delish: 1, product: 1, range: 1, really: 1, actually: 1, completely: 1, exactly: 1, entire: 1, all: 1, use: 1, contain: 1, one: 1, still: 1 };
  /* customer words -> the words the store uses. The typed words always count too, a little more than these. A "~" marks a
     related word, not the same thing: it finds results but never makes an FAQ the answer by itself ("diabetic" is not
     "sugar free"). */
  var sSyn = {
    'jello': ['jel'], 'jell o': ['jel'], 'jelly': ['jel'], 'jelo': ['jel'],
    'sugarfree': ['sugar free'], 'no sugar': ['sugar free'], 'zero sugar': ['sugar free'], 'without sugar': ['sugar free'], 'sugar less': ['sugar free'],
    'dairy free': ['dairy', '~vegan', '~plant based'], 'dairyfree': ['dairy free', 'dairy', '~vegan', '~plant based'], 'non dairy': ['dairy free', 'dairy', '~vegan', '~plant based'],
    'nondairy': ['dairy free', 'dairy', '~vegan', '~plant based'], 'lactose': ['lactose free', 'dairy free', '~vegan', '~plant based'], 'lactose free': ['dairy free', '~vegan', '~plant based'],
    'vegetarian': ['~vegan', '~plant based'], 'plantbased': ['plant based', '~vegan'],
    'creamy': ['~creami'], 'ninja': ['ninja creami'], 'ice cream maker': ['~ninja creami'], 'ice cream': ['~ninja creami'],
    'diabetic': ['diabetes', '~sugar free'], 'diabetes': ['diabetic', '~sugar free'], 'blood sugar': ['diabetic', '~sugar free'],
    'gelatin': ['~gelatin alternative'], 'gelatine': ['gelatin', '~gelatin alternative'], 'agar': ['~gelatin alternative'],
    'keto': ['~low carb', '~carb'], 'low carb': ['~keto', 'carb'], 'carb': ['~keto', '~low carb'], 'carbs': ['~keto', '~low carb'],
    'make': ['prepare', 'directions'], 'directions': ['prepare', 'instructions'], 'instructions': ['prepare', 'directions'],
    'return': ['refund'], 'returns': ['refund'], 'refund': ['return'], 'delivery': ['shipping'], 'shipping': ['delivery'],
    'nutrition': ['nutritional', '~calorie'], 'buy': ['store locator']
  };
  var sIndex = null, sLoading = null;
  function sNorm(s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ™®©'’]/g, '').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\bjell o\b/g, 'jello'); }
  function sStem(w) { return w.length > 3 && /[^s]s$/.test(w) ? w.slice(0, -1) : w; }
  function sEsc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sWords(s) { return s ? sNorm(s).split(' ').filter(Boolean).map(sStem) : []; }
  /* row: [group, title, url, image, note, keywords, body]. An index from before 14 Oct kept pages under the FAQ letter. */
  function sPrep(rows) {
    return rows.map(function (r) {
      var ts = sNorm(r[1]), g = r[0] === 'h' && (r[4] === 'Page' || r[4] === 'Shop') ? 'x' : r[0];
      return { g: g, t: r[1], u: r[2], i: r[3], n: r[4], a: g === 'r' ? '' : (r[6] || ''), ts: ts, T: ts.split(' ').map(sStem), K: sWords(r[5]), B: sWords(r[6]) };
    });
  }
  /* one typo: the two words are a single insert, delete, swap-in or two swapped letters ("protien") apart */
  function sNear(a, b) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > 1) return false;
    if (la === lb) {
      for (var k = 0; k < la && a.charAt(k) === b.charAt(k); k++);
      if (k < la - 1 && a.charAt(k) === b.charAt(k + 1) && a.charAt(k + 1) === b.charAt(k) && a.slice(k + 2) === b.slice(k + 2)) return true;
    }
    var i = 0, j = 0, miss = 0;
    while (i < la && j < lb) {
      if (a.charAt(i) === b.charAt(j)) { i++; j++; continue; }
      if (++miss > 1) return false;
      if (la > lb) i++; else if (lb > la) j++; else { i++; j++; }
    }
    return miss + (la - i) + (lb - j) <= 1;
  }
  function sHit(tok, words, exact, prefix, fuzzy, minPrefix) {
    var best = 0;
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (w === tok) return exact;
      if (tok.length >= minPrefix && w.indexOf(tok) === 0) best = Math.max(best, prefix);
      else if (fuzzy > best && tok.length >= 4 && sNear(tok, w)) best = fuzzy;
    }
    return best;
  }
  /* one word against one row: title 10/7/4/3 > keywords and tags 5/3 > body 2/1 */
  function sField(w, d) {
    var s = sHit(w, d.T, 10, 7, 4, 2);
    if (!s && w.length >= 5 && d.ts.indexOf(w) > -1) s = 3;
    if (s) return { s: s, t: 1 };
    s = sHit(w, d.K, 5, 3, 0, 3) || sHit(w, d.B, 2, 1, 0, 4);
    return s ? { s: s, t: 0 } : null;
  }
  function sSplit(p) { return p.split(' ').filter(function (w) { return w.length > 1 && !sStop[w]; }).map(sStem); }
  /* the query as terms: each term is the typed word (or phrase) plus its synonyms; stopwords drop out */
  function sTerms(q) {
    var words = sNorm(q).split(' ').filter(Boolean), terms = [], i = 0;
    while (i < words.length) {
      var key = '', n;
      for (n = Math.min(3, words.length - i); n >= 1; n--) { if (sSyn[words.slice(i, i + n).join(' ')]) { key = words.slice(i, i + n).join(' '); break; } }
      if (key) {
        var list = [key].concat(sSyn[key]), alts = [], loose = [];
        list.forEach(function (p) { var a = sSplit(p.replace(/^~/, '')); if (a.length) { alts.push(a); loose.push(p.charAt(0) === '~'); } });
        terms.push({ key: key, alts: alts, loose: loose }); i += n; continue;
      }
      if (!sStop[words[i]] && (words[i].length > 1 || /\d/.test(words[i]))) terms.push({ key: words[i], alts: [[sStem(words[i])]] });
      i++;
    }
    return terms;
  }
  function sAsk(q) { return /\?/.test(q) || /^\s*(how|what|whats|what's|can|is|does|do|are|why|where|when|which|will|should)\b/i.test(q); }
  /* how much of a title the query covers: "Is Simply Desserts range VEGAN?" is all about vegan */
  function sCover(d, terms) {
    var W = d.ts.split(' ').filter(function (w) { return w.length > 1 && !sStop[w] && !sFill[sStem(w)]; }).map(sStem);
    if (!W.length) return 0;
    var all = [];
    terms.forEach(function (t) { t.alts.forEach(function (a) { all = all.concat(a); }); });
    return W.filter(function (w) { return all.some(function (a) { return w === a || (a.length >= 3 && w.indexOf(a) === 0) || (w.length >= 3 && a.indexOf(w) === 0); }); }).length / W.length;
  }
  function sScore(d, terms, cq, nq) {
    var score = 0, hit = 0, inT = 0, own = 0;
    for (var i = 0; i < terms.length; i++) {
      var best = null;
      var tIn = 0, oIn = 0, base = terms[i].alts[0];
      terms[i].alts.forEach(function (alt, k) {
        var tot = 0, t = 1;
        for (var j = 0; j < alt.length; j++) { var f = sField(alt[j], d); if (!f) return; tot += f.s; t = t && f.t; }
        if (k) tot *= 0.85;
        if (t) { tIn = 1; if (!(terms[i].loose || [])[k] || alt.every(function (w) { return base.indexOf(w) > -1; })) oIn = 1; }
        if (!best || tot > best.s) best = { s: tot };
      });
      if (best) { hit++; score += best.s; inT += tIn; own += oIn; }
    }
    if (!hit) return null;
    var at = inT === terms.length;
    if (at && terms.length > 1) score += 6;
    if (cq && d.ts === cq) score += 15; else if (cq && d.ts.indexOf(cq) === 0) score += 8; else if (cq && (' ' + d.ts).indexOf(' ' + cq) > -1) score += 5;
    if (nq !== cq && nq.indexOf(' ') > 0 && d.ts.indexOf(nq) > -1) score += 8;   /* the whole question in a title: "Where to Buy ..." */
    var cov = sCover(d, terms);
    return { d: d, s: score + cov * 4 - d.T.length * 0.05, hit: hit, at: at, own: own === terms.length, cov: cov };
  }
  /* Protein Pudding is made with milk: a vegan or dairy-free search never offers it (unless the row says vegan) */
  function sDairy(d) { return /\bprotein\b/.test(d.ts) && /\bpudding/.test(d.ts) && !/\b(vegan|plant)/.test(d.ts); }
  /* Everything a results view needs: { mode: short | popular | none | results, question, answer, groups, total }.
     mode "popular": only stopwords ("the"); "none": nothing matched. The panel and the search page both render this. */
  function sRank(q, idx) {
    var nq = sNorm(q), R = { q: q, mode: 'results', question: sAsk(q), answer: null, groups: [], total: 0 };
    if (nq.length < 2 || !idx) { R.mode = 'short'; return R; }
    var terms = sTerms(q);
    if (!terms.length) { R.mode = 'popular'; return R; }
    var veg = terms.some(function (t) { return t.alts.some(function (a) { return a.some(function (w) { return /^(vegan|plant|dairy|lactose)/.test(w); }); }); });
    var cq = terms.map(function (t) { return sNorm(t.key); }).join(' ');
    function run(need) {
      var out = [];
      idx.forEach(function (d) {
        if (veg && sDairy(d)) return;
        var r = sScore(d, terms, cq, nq);
        /* products sell: on a longer query a product may miss one word ("sugar free pudding mix") */
        if (r && (r.hit >= need || (d.g === 'p' && need >= 3 && r.hit >= need - 1))) out.push(r);
      });
      return out;
    }
    var found = run(terms.length);
    if (!found.length && terms.length > 1) found = run(terms.length - 1);
    if (!found.length) { R.mode = 'none'; return R; }
    var by = {};
    found.forEach(function (r) { (by[r.d.g] = by[r.d.g] || []).push(r); });
    sGroups.forEach(function (g) {
      var rows = by[g[0]];
      if (!rows) return;
      rows.sort(function (x, y) { return y.s - x.s || x.d.T.length - y.d.T.length || (x.d.t < y.d.t ? -1 : 1); });
      R.groups.push({ g: g[0], label: g[1], plural: g[2], best: rows[0].s, all: rows, rows: rows.map(function (r) { return r.d; }) });
    });
    /* FAQ first, Pages last; between them the better best match first, in steps of 2 points so near-ties keep the house
       order. Products get 4 points on the scale: a shopper who types a product's name sees it before recipes using it. */
    var lead = function (g) { return Math.floor((g.best + (g.g === 'p' ? 4 : 0)) / 2); };
    R.groups.sort(function (a, b) {
      var pa = a.g === 'h' ? -1 : a.g === 'x' ? 1 : 0, pb = b.g === 'h' ? -1 : b.g === 'x' ? 1 : 0;
      return pa - pb || (pa ? 0 : lead(b) - lead(a)) || sOrder[a.g] - sOrder[b.g];
    });
    R.total = found.length;
    R.answer = sAnswer(by, R.question);
    /* the FAQ list opens with the question the card answers */
    if (R.answer && R.answer.kind === 'faq') {
      var fg = R.groups[0], at = fg.rows.indexOf(R.answer.d);
      if (at > 0) { fg.rows.splice(at, 1); fg.rows.unshift(R.answer.d); }
    }
    return R;
  }
  /* The best-answer card. Without a question, only an FAQ plainly about the words typed ("shipping", "kosher": every
     word typed in its question, a third of the question or more; all of it when the words also name a product).
     For a question, the best FAQ unless a guide, post or page answers it clearly better ("what is gelatin made of"). */
  function sAnswer(by, question) {
    var faq = by.h || [], prodQ = (by.p || []).some(function (r) { return r.at; });
    var strong = faq.filter(function (r) { return r.own && r.cov >= (prodQ ? 1 : 0.33); })
      .sort(function (x, y) { return y.cov - x.cov || sWide(y.d) - sWide(x.d) || y.s - x.s; })[0];
    if (strong) return { kind: 'faq', d: strong.d };
    if (!question) return null;
    var other = [].concat(by.g || [], by.b || [], by.x || []).filter(function (r) { return r.s >= 8; })
      .sort(function (x, y) { return y.s - x.s || sOrder[x.d.g] - sOrder[y.d.g]; })[0];
    if (faq[0] && faq[0].s >= 8 && (!other || faq[0].s >= other.s * 0.6)) return { kind: 'faq', d: faq[0].d };
    return other ? { kind: other.d.g === 'x' ? 'page' : other.d.g === 'g' ? 'guide' : 'blog', d: other.d } : null;
  }
  /* a question about the whole range ("Is Simply Desserts range ... Sugar-Free?") answers a one-word search best */
  function sWide(d) { return /\b(range|simply desserts|your products?)\b/.test(d.ts) ? 1 : 0; }
  /* the questions shown when a query says nothing yet ("the") or finds nothing */
  var sTopQ = ['how-much-does-shipping-and-handling-cost', 'how-do-i-prepare-simply-delish-instant-puddings', 'sugar-free', 'vegan', 'how-much-protein-is-in-each-serving', 'what-is-simply-desserts-gelatin-alternative', 'when-will-i-receive-my-order', 'how-can-i-return-my-order'];
  function sTopFaq(idx, n) {
    var faq = (idx || []).filter(function (d) { return d.g === 'h'; }), out = [];
    sTopQ.forEach(function (h) { var d = faq.filter(function (x) { return x.u.slice(-(h.length + 3)) === '#q-' + h; })[0]; if (d) out.push(d); });
    return out.concat(faq.filter(function (d) { return out.indexOf(d) < 0; })).slice(0, n);
  }
  /* /sd-search-core */

  var sBox = $('[data-search]');
  var sPopularTerms = ['Protein Pudding', 'Keto', 'Sugar Free', 'Ninja™ CREAMi®', 'Jel', 'Gelatin Alternative', 'Cheesecake', 'Build a Box'];
  function sLoad() {
    if (sIndex) return Promise.resolve(sIndex);
    if (!sLoading) sLoading = fetch(sBox.dataset.index).then(function (r) { return r.json(); }).then(function (rows) { sIndex = sPrep(rows); return sIndex; });
    return sLoading;
  }
  function sUrl(d) {
    var u = d.u.charAt(0) === '~' ? window.sdRoutes.recipe.replace('{h}', d.u.slice(1)) : d.u;
    return sAbs(u);
  }
  function sAbs(u) {
    var root = sBox.dataset.root;
    return u.charAt(0) === '/' && root && root !== location.origin ? root + u : u;
  }
  function sImg(u, w) { return u.indexOf('cdn.shopify.com') > -1 ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : u; }
  function sMark(text, q) {
    var words = [];
    sTerms(q).forEach(function (t) { t.alts.forEach(function (a) { a.forEach(function (w) { if (w.length > 1 && words.indexOf(w) < 0) words.push(w); }); }); });
    if (!words.length) return sEsc(text);
    var parts = text.split(new RegExp('\\b((?:' + words.join('|') + ')s?\\b|(?:' + words.join('|') + '))', 'gi'));
    return parts.map(function (p, i) { return i % 2 ? '<mark>' + sEsc(p) + '</mark>' : sEsc(p); }).join('');
  }
  /* a link that leaves this site (a hub before the cutover) opens in a new tab and says so */
  function sLink(d, cls, inner, label) {
    var u = sUrl(d), out = /^https?:/.test(u) && u.indexOf(location.origin) !== 0;
    return '<a class="' + cls + '" href="' + sEsc(u) + '"' + (out ? ' target="_blank" rel="noopener"' : '') + '>' + inner + (label ? '<span class="visually-hidden">: ' + sEsc(label) + '</span>' : '') + (out ? '<span class="visually-hidden"> (opens in a new tab)</span>' : '') + '</a>';
  }
  function sCount(R) {
    return R.groups.map(function (g) { return g.rows.length + ' ' + g.plural; }).join(', ');
  }
  function sPageUrl(q, type) { return sBox.dataset.searchUrl + '?q=' + encodeURIComponent(q) + (type ? '&type=' + type : ''); }
  /* the best-answer card, the same on the panel and the search page */
  function sCard(A, q) {
    var d = A.d, kicker = { faq: 'Answer From Our FAQ', guide: 'From Our Guides', blog: 'From Our Blog', page: 'Best Match' }[A.kind];
    var go = A.kind === 'faq' ? 'Read the Answer' : A.kind === 'page' ? 'Open the Page' : 'Read the Guide';
    if (A.kind === 'blog') go = 'Read the Post';
    return '<section class="sanswer" aria-label="Best answer"><p class="sanswer__kicker">' + kicker + (A.kind === 'faq' && d.n && d.n !== 'FAQ' ? '<span>' + sEsc(d.n) + '</span>' : '') + '</p>' +
      '<h2 class="sanswer__q">' + sMark(d.t, q) + '</h2>' + (d.a ? '<p class="sanswer__a">' + sEsc(d.a) + '</p>' : '') +
      sLink(d, 'sanswer__go', go + ' <span aria-hidden="true">→</span>', d.t) + '</section>';
  }
  function sChipList() {
    var have = sBox && $$('[data-search-start] [data-search-term]', sBox).map(function (b) { return b.dataset.searchTerm; });
    return have && have.length ? have : sPopularTerms;
  }
  function sChips() {
    return '<ul class="sfind__chips">' + sChipList().map(function (t) { return '<li><button type="button" data-search-term="' + sEsc(t) + '">' + sEsc(t) + '</button></li>'; }).join('') + '</ul>';
  }
  function sFaqLine(d, q, cls) {
    return '<li>' + sLink(d, cls, '<span><b>' + sMark(d.t, q) + '</b>' + (d.a ? '<span class="sfaq__a">' + sEsc(d.a) + '</span>' : '') + (d.n && d.n !== 'FAQ' ? '<small>' + sEsc(d.n) + '</small>' : '') + '</span>') + '</li>';
  }
  /* only stopwords ("the") or nothing found: popular searches, the top questions, and a way to ask us */
  function sHelpful(q, mode, faqCls) {
    var head = mode === 'none'
      ? '<p class="sfind__none">No exact match for “' + sEsc(q) + '”. Try one of these, or ask us.</p>'
      : '<p class="sfind__none">Search by product, flavor, diet or question. Popular right now:</p>';
    var faqs = sTopFaq(sIndex, 4);
    return head + sChips() +
      (faqs.length ? '<section class="sfind__top"><h2>Top Questions</h2><ul class="sfind__faqs">' + faqs.map(function (d) { return sFaqLine(d, '', faqCls); }).join('') + '</ul></section>' : '') +
      '<p class="sfind__ask"><a href="' + sEsc(sAbs('/pages/helpcenter')) + '">Browse All FAQ</a><a href="' + sEsc(sAbs('/pages/contact')) + '">Contact Us</a></p>';
  }

  if (sBox) {
    var sInput = $('[data-search-input]', sBox), sStart = $('[data-search-start]', sBox), sOut = $('[data-search-results]', sBox), sStatus = $('[data-search-status]', sBox);
    var sFrom = null, sTimer;
    var sShow = function () {
      var q = sInput.value.trim(), R = sRank(q, sIndex), html = '';
      if (R.mode === 'short') { sOut.hidden = true; sOut.innerHTML = ''; sStart.hidden = false; sStatus.textContent = ''; return; }
      sStart.hidden = true; sOut.hidden = false;
      if (R.mode !== 'results') {
        sOut.innerHTML = sHelpful(q, R.mode, 'sfind__item sfind__item--h sfind__item--text');
        sStatus.textContent = R.mode === 'none' ? 'No exact match for ' + q + '. Showing popular searches and top questions.' : 'Showing popular searches and top questions.';
        return;
      }
      R.groups.forEach(function (g) {
        var top = g.rows.slice(0, g.g === 'p' || g.g === 'r' ? 4 : 3);
        html += '<section class="sfind__group sfind__group--' + g.g + '"><h2><span>' + g.label + ' (' + g.rows.length + ')</span>' +
          (g.rows.length > top.length ? '<a href="' + sEsc(sPageUrl(q, g.g)) + '">See all<span class="visually-hidden"> ' + g.rows.length + ' ' + g.plural + '</span></a>' : '') + '</h2><ul>' +
          top.map(function (d) {
            if (d.g === 'h') return sFaqLine(d, q, 'sfind__item sfind__item--h sfind__item--text');
            var body = '<span><b>' + sMark(d.t, q) + '</b>' + (d.n ? '<small>' + sEsc(d.n) + '</small>' : '') + '</span>';
            return '<li>' + sLink(d, 'sfind__item sfind__item--' + d.g + (d.i ? '' : ' sfind__item--text'), (d.i ? '<img src="' + sEsc(sImg(d.i, 120)) + '" alt="" width="52" height="52" loading="lazy">' : '') + body) + '</li>';
          }).join('') + '</ul></section>';
      });
      sOut.innerHTML = (R.answer ? sCard(R.answer, q) : '') + '<div class="sfind__cols">' + html + '</div><div class="sfind__all"><a class="btn" href="' + sEsc(sPageUrl(q)) + '">See All ' + R.total + ' Result' + (R.total === 1 ? '' : 's') + '</a></div>';
      sStatus.textContent = (R.answer ? 'Best answer: ' + R.answer.d.t + '. ' : '') + R.total + ' result' + (R.total === 1 ? '' : 's') + ': ' + sCount(R);
    };
    var setSearch = function (open) {
      if (open === !sBox.hidden) return;
      if (open) {
        sFrom = document.activeElement;
        if (sheet && sheet.classList.contains('is-open')) { setSheet(false); sFrom = $('.site-header [data-search-open]'); }
        sBox.hidden = false;
        document.body.classList.add('search-open');
        sInput.focus(); sInput.select();
        sLoad().then(sShow);
      } else {
        sBox.hidden = true;
        document.body.classList.remove('search-open');
        if (sFrom && sFrom.focus && sFrom.offsetParent !== null) sFrom.focus();
      }
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); setSearch(true); return; }
      if (e.target.closest('[data-search-close]')) { setSearch(false); return; }
      var term = e.target.closest('[data-search-term]');
      if (term && sBox.contains(term)) { sInput.value = term.dataset.searchTerm; sInput.focus(); sLoad().then(sShow); }
    });
    sInput.addEventListener('input', function () { clearTimeout(sTimer); sTimer = setTimeout(function () { sLoad().then(sShow); }, 70); });
    $('form', sBox).addEventListener('submit', function (e) { if (!sInput.value.trim()) e.preventDefault(); });
    sBox.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); setSearch(false); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var stops = [sInput].concat($$('a[href], button', sOut)), at = stops.indexOf(document.activeElement);
        if (at < 0 || stops.length < 2) return;
        e.preventDefault();
        stops[(at + (e.key === 'ArrowDown' ? 1 : stops.length - 1)) % stops.length].focus();
        return;
      }
      if (e.key === 'Tab') {
        var f = $$('a[href], button, input', $('.sfind__panel', sBox)).filter(function (el) { return el.offsetParent !== null; });
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    /* "/" or Ctrl/Cmd + K opens search from anywhere outside a text field */
    document.addEventListener('keydown', function (e) {
      var typing = /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName) || e.target.isContentEditable;
      if ((e.key === '/' && !typing && !e.ctrlKey && !e.metaKey && !e.altKey) || ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k')) {
        if ($('[data-spage-input]') && sBox.hidden) { e.preventDefault(); $('[data-spage-input]').focus(); return; }
        e.preventDefault(); setSearch(true);
      }
    });
  }

  /* search page: the same sRank() as the panel, every result; tabs filter by group; typing updates the list and the address */
  var sPage = $('[data-spage]');
  if (sPage && sBox) {
    var pIn = $('[data-spage-input]'), pOut = $('[data-spage-out]', sPage), pTabs = $('[data-spage-tabs]', sPage), pSum = $('[data-spage-sum]', sPage), pOld = $('[data-spage-fallback]');
    var pType = (new URLSearchParams(location.search).get('type') || '').replace(/[^a-z]/g, ''), pLimit = 24, pTimer;
    var pCard = function (d, q) {
      if (d.g === 'h') return sFaqLine(d, q, 'spage__faq');
      if (d.g === 'x') return '<li>' + sLink(d, '', '<span>' + sMark(d.t, q) + '</span><small>' + sEsc(d.n) + '</small>') + '</li>';
      return '<li>' + sLink(d, 'scard scard--' + d.g, (d.i ? '<img src="' + sEsc(sImg(d.i, 480)) + '" alt="" loading="lazy">' : '<div class="scard__blank"></div>') + '<b>' + sMark(d.t, q) + '</b>' + (d.n ? '<small>' + sEsc(d.n) + '</small>' : '')) + '</li>';
    };
    var pShow = function () {
      var q = pIn.value.trim(), R = sRank(q, sIndex), html = '';
      if (R.mode === 'short') { pSum.textContent = 'Type at least two letters to search answers, products, recipes and guides.'; pTabs.innerHTML = ''; pOut.innerHTML = ''; return; }
      if (R.mode !== 'results') {
        pSum.textContent = R.mode === 'none' ? 'No exact match for “' + q + '”.' : 'Popular searches and top questions';
        pTabs.innerHTML = '';
        pOut.innerHTML = '<div class="spage__help">' + sHelpful(q, R.mode, 'spage__faq').replace(/<p class="sfind__none">[\s\S]*?<\/p>/, '') + '</div>';
        return;
      }
      var by = {};
      R.groups.forEach(function (g) { by[g.g] = g; });
      if (!by[pType]) pType = '';
      pSum.textContent = R.total + ' result' + (R.total === 1 ? '' : 's') + ' for “' + q + '”';
      pTabs.innerHTML = '<button type="button" data-spage-tab="" aria-pressed="' + (pType ? 'false' : 'true') + '">All (' + R.total + ')</button>' +
        R.groups.map(function (g) { return '<button type="button" data-spage-tab="' + g.g + '" aria-pressed="' + (pType === g.g) + '">' + g.label + ' (' + g.rows.length + ')</button>'; }).join('');
      if (R.answer && (!pType || pType === 'h')) html += sCard(R.answer, q);
      R.groups.forEach(function (g) {
        if (pType && pType !== g.g) return;
        var list = g.g === 'h' || g.g === 'x', cap = pType ? pLimit : (g.g === 'h' ? 4 : list ? 6 : 8), top = g.rows.slice(0, cap);
        html += '<section class="spage__group"><h2>' + g.label + ' <span>(' + g.rows.length + ')</span></h2><ul class="' + (g.g === 'h' ? 'spage__faqs' : list ? 'spage__list' : 'spage__grid' + (pType ? '' : ' spage__grid--one')) + '">' +
          top.map(function (d) { return pCard(d, q); }).join('') + '</ul>' +
          (g.rows.length > top.length ? '<div class="spage__more"><button class="btn btn--outline" type="button" ' + (pType ? 'data-spage-more' : 'data-spage-tab="' + g.g + '"') + '>' + (pType ? 'Show More' : 'See All ' + g.rows.length + ' ' + g.label) + '</button></div>' : '') + '</section>';
      });
      pOut.innerHTML = html;
    };
    var pAddress = function () {
      var u = new URL(location.href);
      u.searchParams.set('q', pIn.value.trim());
      if (pType) u.searchParams.set('type', pType); else u.searchParams.delete('type');
      history.replaceState(null, '', u);
    };
    sLoad().then(function () { if (pOld) pOld.hidden = true; sPage.hidden = false; pShow(); });
    pIn.addEventListener('input', function () { clearTimeout(pTimer); pTimer = setTimeout(function () { pLimit = 24; sLoad().then(pShow).then(pAddress); }, 90); });
    pIn.form.addEventListener('submit', function (e) { if (!sIndex) return; e.preventDefault(); pShow(); pAddress(); });
    sPage.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-search-term]');
      if (chip) { pIn.value = chip.dataset.searchTerm; pType = ''; pLimit = 24; pShow(); pAddress(); pIn.focus(); return; }
      var tab = e.target.closest('[data-spage-tab]');
      if (tab) {
        var jump = !tab.closest('[data-spage-tabs]');
        pType = tab.dataset.spageTab; pLimit = 24; pShow(); pAddress();
        var now = $('[data-spage-tab="' + pType + '"]', pTabs);
        if (now) now.focus();
        if (jump) pTabs.scrollIntoView({ block: 'center' });
        return;
      }
      if (e.target.closest('[data-spage-more]')) { pLimit += 24; pShow(); }
    });
  }
})();

// Shopify's injected captcha response fields arrive unlabelled; label them so audits stay clean.
(function () {
  var label = function () {
    document.querySelectorAll('textarea[name="h-captcha-response"], textarea[name="g-recaptcha-response"]').forEach(function (t) {
      if (!t.hasAttribute('aria-label')) { t.setAttribute('aria-label', 'Captcha response'); t.setAttribute('aria-hidden', 'true'); t.tabIndex = -1; }
    });
  };
  label();
  new MutationObserver(label).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Find Your Flavor phone dropdown: picking a range clicks its tab (bound here, not inline, so WAVE reads it as a filter, not a jump menu) */
document.addEventListener('change', function (e) {
  if (!e.target.matches || !e.target.matches('.flavors__pick')) return;
  var t = document.getElementById(e.target.value);
  if (t) t.click();
});

/* product page fact headings come from product data in sentence case ("How to make it"); show them in title case */
(function () {
  var small = /^(a|an|and|as|at|but|by|for|in|of|on|or|the|to|with)$/i;
  document.querySelectorAll('.fact-card h2').forEach(function (h) {
    if (h.children.length) return;
    var w = h.textContent.trim().split(/\s+/);
    h.textContent = w.map(function (x, i) {
      return (i > 0 && i < w.length - 1 && small.test(x)) ? x.toLowerCase() : x.charAt(0).toUpperCase() + x.slice(1);
    }).join(' ');
  });
})();
